import { formatDate } from 'ClientService';

export const Answered = (record, context) => {
  const { settings } = context;

  const poolRequestConfirmationOfReceipt = settings?.poolRequestConfirmationOfReceipt || false;

  let now = new Date();
  let answerCompDate = !record.toAnswerDate ? null : new Date(record.toAnswerDate.getFullYear(),
    record.toAnswerDate.getMonth(), record.toAnswerDate.getDate(), 23, 59, 59);

  let tsdCompDate = !record.toSubsequentDeliveryDate ? null : new Date(record.toSubsequentDeliveryDate.getFullYear(),
    record.toSubsequentDeliveryDate.getMonth(), record.toSubsequentDeliveryDate.getDate(), 23, 59, 59);

  if(record.submitDate) {
    return `${ poolRequestConfirmationOfReceipt ? 'Bestätigt' : 'Formal korrekt' }: ${formatDate(record.submitDate)}`
  }
  else if(record.answerDate && !record.submitDate) {
    return `Beantwortet, nicht bestätigt: ${formatDate(record.answerDate)}`;
  }
  else if(record.answerDate) {
    return `Beantwortet: ${formatDate(record.answerDate)}`;
  }
  else if( !record.isCareProviderResponse && ( ( !tsdCompDate && answerCompDate < now ) || ( !!tsdCompDate && tsdCompDate < now ) ) ) {
    let lastDate = record.toSubsequentDeliveryDate ? record.toSubsequentDeliveryDate : record.toAnswerDate;
    return `Abgelaufen: ${formatDate(lastDate)}`;
  }
  else if( record.answerInbox && ( ( !tsdCompDate && answerCompDate >= now ) || ( !!tsdCompDate && tsdCompDate >= now ) ) ) {
    return `Im LE-Postfach`;
  }
  else if(record.readDate) {
    return `Gelesen: ${formatDate(record.readDate)}`;
  }

  return `Ungelesen`;
}
